<template>
  <div class="pagesContent">
    <el-container class="container">
      <el-header height="50px">
        <el-row class="header-title">
          <el-col :span="2">
            <h4>电脑名 黑名单</h4>
          </el-col>
          <el-col :span="2" :offset="20">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addComputer">添加电脑名</el-button>
          </el-col>
        </el-row>
      </el-header>
      <!-- 黑名单列表 -->
      <div>
        <el-table :data="blackList" stripe border style="width: 100%" height="720">
          <el-table-column type="index" label="编号" align="center" width="80"></el-table-column>
          <el-table-column label="电脑名称" align="center" >
            <template slot-scope='scope'>
              {{scope.row}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" circle @click="deleteRowComputer(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 删除提示框 -->
      <el-dialog
        title="提示"
        :visible.sync="dialogDelete"
        width="30%">
        <span>您确定要将 "{{computerValue}}" 移出黑名单吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogDelete = false">取 消</el-button>
          <el-button type="primary" @click="SubmitDelete">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 添加 -->
      <el-dialog
        title="移入黑名单"
        :visible.sync="dialogAdd"
        width="30%"
        @close="onCloseAdd">
        <el-form :model="addForm" :rules="addRules" ref="addForm">
          <el-form-item label="电脑名称" prop="computerName">  <!-- :label-width="formLabelWidth" -->
            <el-input v-model="addForm.computerName" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAdd = false">取 消</el-button>
          <el-button type="primary" @click="SubmitAdd('addForm')">提 交</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
  export default {
    data() {
      //电脑名称是否存在
      var validateComputerName = (rule, value, callback) => {
          var computerName = value
          if(computerName != ''){
            let computer = '?computerName=' + computerName
            this.$http.judgeExistsComputer(computer).then(res=>{
              if(res.data){  //true 已存在 不通过验证
                callback(new Error('此电脑名称已存在,请勿重复添加！'))
              }else{ //false 不存在 通过验证
                callback()
              }
            })
          }
        }
      return{
        //电脑名 黑名单列表
        blackList:[],
        //选中行 索引、电脑名
        index: null,
        computerValue:'',
        //删除弹出框
        dialogDelete: false,
        //添加弹出框
        dialogAdd: false,
        // formLabelWidth: '80px',
        //添加表对象
        addForm:{
          computerName:''
        },
        //添加规则
        addRules:{
            computerName: [{ required: true, message: '请输入电脑名称', trigger: 'blur' },
                           { validator: validateComputerName, trigger: 'blur' }]
        }
      }
    },
    mounted() {
      //查询电脑名黑名单
      this.getAllBlankList()
    },
    methods:{
      //弹窗关闭时重置表单
      onCloseAdd() {
        this.$refs['addForm'].resetFields()
      },
      //添加电脑名
      addComputer(){
        this.dialogAdd = true
      },
      /* 提交添加 */
      SubmitAdd(addForm){
        // 调用接口
				// return console.log(addForm)
        this.$refs[addForm].validate((valid) =>{
          if(valid){  //验证成功 返回 true 提交数据
            //添加接口
            let computer = '?computerName=' + this.addForm.computerName
            this.$http.addBlackComputer(computer).then(res=>{
              if(res.status == 200){
                this.dialogAdd = false  //关闭弹框
                this.$message.success({  //消息提示
                  message: '添加成功！'
                })
                this.getAllBlankList() //重新查询
              }
            })
          }else{  //验证失败
              return false;
          }
        })
      },
      /* 删除 */
      deleteRowComputer(index,row){
        this.index = index
        this.computerValue = row
        // 弹出提示框
        this.dialogDelete = true
      },
      /* 提交删除 */
      SubmitDelete() {
        var index = this.index
        let computer = '?computerName=' + this.blackList[index]
        this.$http.deleteBlackComputer(computer).then(res=>{
          if(res.status == 200){
            this.dialogDelete = false  //关闭弹框
            this.$message.success({  //消息提示
              message: '操作成功！'
            })
            this.getAllBlankList() //重新查询
          }
        })
        // this.dialogDelete = false
      },
      /* 查询所有电脑名黑名单 */
      getAllBlankList(){
        this.$http.getBlackAll().then(res=>{
          if(res.status == 200){
            this.blackList = res.data
          }else{
              this.$message.error({
                message: '查询黑名单失败！'
              })
          }
        })
      }
    }
  }

</script>

<style>
.container{
  padding-top: 20px;
}
</style>
